<template>
    <div class="card">
        <div class="card-body">
            <!-- <button  type="button" @click="BillGeneration()" class="btn btn-primary contct-b "><i class="fa fa-life-bouy"></i> Add {{this.$route.name}}</button> &nbsp;&nbsp; -->

            <button type="button" v-if="permission.water_bill_create" @click="addPostModal()" class="btn btn-primary contct-b "><i class="fa fa-life-bouy"></i> Add post</button>
            <!-- <button style="margin-left: 10px"  type="button" @click="billgenerate()" class="btn btn-primary contct-b "><i class="fa fa-life-bouy"></i> Bill Generate</button> -->
            <button v-if="invoice_type == 'water-billing' && permission.water_bill_create" type="button" @click="WardBillgenerate()" class="btn btn-primary contct-b ml-2"><i class="fa fa-life-bouy"></i> Bill By Ward</button>
            <button v-if="permission.water_bill_create"  type="button" @click="billCreate()" class="btn btn-primary contct-b ml-0 ml-sm-2"><i class="fa fa-dollar"></i> Create New Bill</button>
            <form @submit.prevent="getResults()" class="form-inline contct my-2 my-lg-0 pull-right">
                <select class="form-control" v-model="search.ward">
                        <option v-if="$route.name =='Water billing'" value="">ওয়ার্ড সিলেক্ট করুন</option>
                        <option v-for=" ward in wards" :key="ward.id" :value="ward.id">{{ ward.name}}{{ ward.ward_name_bng}}</option>
                    </select>
                &nbsp;&nbsp;
                <input name="personal_note" v-model="search.account_no" type="tex" class="form-control" id="inputPassword3" placeholder="একাউন্ট নম্বর"> &nbsp;&nbsp;

                <select  name="Customer" v-model="search.status"  class="form-control" >
                    <option value="">Select Status</option>
                    <option value="0">Unpaid</option>
                    <option value="1">Paid</option>
                    <option value="5">partial Unpaid</option>
                </select>
                &nbsp;&nbsp;
                <button type="submit" class="btn btn-success my-2 my-sm-0" >Search</button>
            </form>
            <button v-if="permission.special_permission_update"  type="button" @click="dueChargeOff()" class="btn btn-primary contct-b ">Due Charge Off</button>
            <table class="table table-sm">
                <thead>
                    <tr>
                    <th scope="col">#</th>
                    <th scope="col">তারিখ</th>
                    <th scope="col">ক্রমিক সংখ্যা</th>
                    <th scope="col">নাগরিক</th>
                    <th scope="col">হিসাব নাম্বার</th>
                    <th scope="col">পরিমাণ</th>
                    <th scope="col">Status</th>
                    <th class="text-center" scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(invoice,index) in invoices.data" :key="index">
                        <td>{{indexf(index)}}</td>
                        <td>{{invoice.date | formatAppDate}}</td>
                        <td>{{invoice.invoice_number}}</td>
                        <td>{{invoice.customer}}</td>
                        <td>{{invoice.account_no}}</td>
                        <td>{{invoice.total}}</td>
                        <td><span  v-if="invoice.status==1">Paid</span> <span v-if="invoice.status==5">Partial Unpaid</span> <span v-if="invoice.status==0">Unpaid</span></td>
                        <td class="text-center">
                            <i v-if="permission.special_permission_update" @click="editInvoiceModal(invoice)" class="icon-note icons actn"></i>
                            <!-- <i v-if="permission.invoice_update || permission.invoice_update_all" @click="editInvoiceModal(invoice,index)" class="icon-note icons actn"> </i> -->
                            <!-- <i @click="viewInvoiceModal(invoice)" class="icon-eye icons   actn"> </i> -->
                            <button v-if="permission.water_bill_create" class="btn-xs btn btn-info actn"><i @click="singleBillPrint(invoice.id)" class="fa fa-print"> </i></button>
                            <span v-if="invoice.status==0 && permission.water_bill_create" class="actn" @click="partialBill(invoice)"><button class="btn-xs btn btn-secondary">Partial</button></span>
                            <span v-if="invoice.status==1 && permission.water_bill_create" class="actn" @click="unpaidBill(invoice.id)"><button class="btn-xs btn btn-warning">Unpay</button></span>
                            <!-- <i v-if="permission.invoice_delete || permission.invoice_delete_all" @click="deleteInvoice(index,invoice.id)" class="icon-trash icons   actn"> </i> -->
                        </td>
                    </tr>
                </tbody>
            </table>
            <nav aria-label="Page navigation example">
                <pagination :data="invoices" @pagination-change-page="getResults" :limit="8"></pagination>
            </nav>
        </div>
        <!-- <WaterBillingAdd v-if="invoice_type=='water-billing'" ref="add_invoice_modal" :invoice_type="invoice_type"></WaterBillingAdd>
        <InvoiceAddModal v-else ref="add_invoice_modal" :invoice_type="invoice_type"></InvoiceAddModal> -->
        <BillPost ref="add_post_modal"  :invoice_type="invoice_type"></BillPost>
        <!-- <InvoiceViewModal ref="view_invoice_modal"></InvoiceViewModal> -->
        <WardByBill  ref="bill_search_ward"></WardByBill>
        <WaterBillViewModal ref="view_bill_modal"></WaterBillViewModal>
        <!-- <BillGenerationModal :invoice_type="invoice_type" ref="bill_generation_modal"></BillGenerationModal> -->
        <DueChargeOff ref="due_charge_off_modal"></DueChargeOff>
        <BillCreate ref="bill_create_modal"></BillCreate>
        <WaterBillingEdit ref="edit_invoice_modal" :invoice_type="invoice_type"></WaterBillingEdit>
        <PartialBill ref="partial_bill_modal"></PartialBill>
        <Loader v-if="loading"></Loader>
    </div>
</template>

<script>
import Loader from '../common/Loader'
import pagination from 'laravel-vue-pagination'
import axios from 'axios'
import BillPost from './Paurasheba/BillPost'
// import BillGenerationModal from './Paurasheba/BillGenerationModal'
import WaterBillViewModal from './WaterBillViewModal'
import WaterBillingAdd from './Paurasheba/WaterBillingAdd'
import WaterBillingEdit from './Paurasheba/WaterBillingEdit'
import DueChargeOff from './DueChargeOff'
// import InvoiceViewModal from './InvoiceViewModal'
import BillCreate from './BillCreate'
import PartialBill from './PartialBill'


import { mapGetters } from "vuex"

import WardByBill from './WardByBill'
export default {
    data(){
        return {
            loading:false,
            permission:'',
            invoice_type:'',
            search:{
                invoice_type:'',
                account_no:'',
                status:'',
                ward:''
            },
            billGenerateForm:{
                exportVal:'pdf'
            },
            index2:0,
        }
    },
    methods:{

        WardBillgenerate(){
            // alert(this.invoice_type)
            this.$refs.bill_search_ward.openModal(this.invoice_type)
        },
        dueChargeOff(){
            //alert(this.invoices.data[0].secret_pin)
            let secret_pin = this.invoices.data[0].secret_pin
            this.$refs.due_charge_off_modal.openModal(this.invoice_type,secret_pin)
        },
        billgenerate(){
            window.open(axios.defaults.baseURL+'/water/bill/generate?export=pdf')
            this.$router.push('/water-billing/list')
        },
        addPostModal(){
            this.$refs.add_post_modal.openModal()
        },
        BillGeneration(){
            this.$refs.bill_generation_modal.OpenModal();
        },
        indexf(index){
            return this.index2+index;
        },
        singleBillPrint(id){
            if(this.$route.name =='Water billing'){
                window.open(`${axios.defaults.baseURL}/water/bill/generate?invoice_id=${id}`)
            }

            if(this.$route.name =='Market billing'){
                window.open(`${axios.defaults.baseURL}/market/bill/generate?invoice_id=${id}`)
            }
        },
        getResults(page=1){
            this.loading = true;
            this.search.invoice_type = this.invoice_type;
            var data = this.search
            this.$store.dispatch('SEARCH_INVOICE',{page,data}).then(response=>{
                this.loading=false;
                this.index2=response.data.meta.from;
            })
            .catch(error=>{
                this.loading=false;
            });
        },
        getBills(page=1){
            this.loading = true;
            this.search.invoice_type = this.invoice_type;
            this.search.ward = ''
            this.search.account_no = ''
            this.search.status = ''
            var data = this.search
            this.$store.dispatch('SEARCH_INVOICE',{page,data}).then(response=>{
                this.loading=false;
                this.index2=response.data.meta.from;
            })
            .catch(error=>{
                this.loading=false;
            });
        },
        addInvoiceModal(){
            this.$refs.add_invoice_modal.openModal()
        },
        editInvoiceModal(invoice,index){
            this.$refs.edit_invoice_modal.openModal(invoice,index)
        },
        viewInvoiceModal(invoice){
            // alert("ok");
            this.$refs.view_bill_modal.openModal(invoice)
        },
        billCreate(){
            var invoice_type = this.invoice_type
            axios.post('/api/last-bill-month',{invoice_type}).then(response=>{
                //alert(response.data)
                this.$refs.bill_create_modal.openModal(response.data)
            })

        },
        partialBill(invoice){
            this.$refs.partial_bill_modal.openModal(invoice)
        },
        unpaidBill(invoice_id){
            var self = this
            this.$swal({
                title: 'Do you want to make unpaid ?',
                showDenyButton: true,
                confirmButtonText: `Yes`,
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post('/api/unpay-bill',{invoice_id}).then(response=>{
                        self.getBills();
                        self.$swal('Saved!', '', 'success')
                    })
                }
            })
        },
        allRole(){
            this.$store.dispatch('ALL_USER_ROLE')
        },
        getPermission(){
            this.$store.dispatch('ALL_USER_ROLE2')
            .then(response=>{
                this.permission = response.data.permission
            })
        }
    },
    mounted(){
        if(this.$route.name=='Water billing'){
            this.invoice_type ='water-billing';
        }else if(this.$route.name=='Market billing'){
            this.invoice_type ='market-billing';
        }
        var invoice_type = this.invoice_type;
        this.$store.dispatch('WARD_LIST',{invoice_type})
        this.allRole();
        this.getPermission();
    },
    computed: {
        ...mapGetters(["invoices","wards","user_roles"]),
    },
    watch: {
        '$route.name': {
            handler: function() {
                if(this.$route.name=='Water billing'){
                    this.invoice_type='water-billing';
                }else if(this.$route.name=='Market billing'){
                    this.invoice_type='market-billing';
                }
                this.getResults()
                var invoice_type = this.invoice_type
                this.$store.dispatch('WARD_LIST',{invoice_type})
            },
            deep: true,
            immediate: true
        }
    },
    components: {
        Loader,
        pagination,
        WaterBillingAdd,
        WaterBillViewModal,
        BillPost,
        // BillGenerationModal,
        WardByBill,
        BillCreate,
        PartialBill,WaterBillingEdit,DueChargeOff
    }
}
</script>


<style>
 .actn{
     margin-left: 5px;
     cursor: pointer;
 }
 .actn .btn,.actn{ padding: 3px 5px;}
 .contct{
     padding-bottom: 10px;
     _padding-top: 10px
 }
 .contct-b{
     margin-bottom: 10px;
     _margin-top: 10px
 }
 .load{
     margin-left: 50%;
 }
</style>
